import { CLIENT_PREFIX } from 'app/remote/client/constants';
import { BEHIND_BROKEN_PROXY_ID } from 'app/models/sessionStorage/constants';
import { getItem } from 'app/models/sessionStorage/selectors';

export const getClient = (state) => state.get(CLIENT_PREFIX);

export const getClientOutdated = (state) => {
  const { clientOutdated } = getClient(state);
  return clientOutdated;
};

export const getInteractiveReloadRequired = (state) => {
  const { interactiveReloadRequired } = getClient(state);
  return interactiveReloadRequired;
};

export const getIsBehindBrokenProxy = (state) => getItem(state, BEHIND_BROKEN_PROXY_ID) === true;
